export default function PageHeading() {
  return (
    <h1 className="page-heading">
      Awesome Scalability Talks
    </h1>
  );
}
